import { FC, useCallback, useState } from "react";
import { Control, useController } from "react-hook-form";

import TimeSelectionRadioGroup, {
  TimeSelectionRadioGroupProps,
} from "./TimeSelectionRadioGroup.tsx";

type ControlledSelectionRadioGroupProps = Omit<
  TimeSelectionRadioGroupProps,
  "value" | "onChange"
> & {
  control: Control<any>;
};

const ControlledTimeSelectionRadioGroup: FC<ControlledSelectionRadioGroupProps> = ({
  control,
  name,
  ...props
}) => {
  const { field } = useController({
    control,
    name,
  });
  const [value, setValue] = useState<string>(field.value);

  const onSingleChange = useCallback(
    (newValue: string) => {
      setValue(newValue);
      field.onChange(newValue);
    },
    [field],
  );

  return <TimeSelectionRadioGroup name={name} onChange={onSingleChange} value={value} {...props} />;
};

export default ControlledTimeSelectionRadioGroup;
